/* eslint-disable prettier/prettier */
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

export const endpoint = process.env.REACT_APP_API_URL || 'http://localhost:5002/api/v1'
export const static_endpoint = process.env.REACT_APP_PLAIN_API_URL || 'http://localhost:5002/'
export const beta_endpoint = process.env.REACT_APP_API_URL_BETA || 'http://localhost:5002/api/beta'
export const EPAPER_API_URL = '/epaper/'
export const IMAGE_RESIZER_URL =
  process.env.REACT_APP_IMAGE_RESIZER_DOMAIN ||
  'https://cmsimages.timesgroup.com' + '/image-resizer/'
// export const endpoint = process.env.REACT_APP_API_URL || 'http://3.7.81.101:5010/api/v1'
// export const beta_endpoint = process.env.REACT_APP_API_URL_BETA || 'http://3.7.81.101:5010/api/beta'

const baseUrl = endpoint

export const get = async (url, token = null, obj = {}) => {
  try {
    const headers = {
      'Content-Type': obj.content_type ?? 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    }

    const response = await fetch(`${baseUrl}${url}`, {
      headers,
    })
    let data
    if (obj.content_type === 'application/pdf') data = await response.arrayBuffer()
    else if (obj.content_type === 'application/png') data = await response.blob()
    else if (obj.content_type === 'application/json') data = await response.blob()
    else if (obj.content_type === 'text/plain') data = await response.text()
    else data = await response.json()
    return data
  } catch (error) {
    console.log('error: ', error)
    throw error
  }
}

export const post = async (url, val, token = null) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    }

    const response = await fetch(`${baseUrl}${url}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(val),
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.log('error: ', error)
    throw error
  }
}

export const put = async (url, val, token = null) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    }

    const response = await fetch(`${baseUrl}${url}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(val),
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.log('error: ', error)
    throw error
  }
}

export const patch = async (url, val, token = null) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    }

    const response = await fetch(`${baseUrl}${url}`, {
      method: 'PATCH',
      headers,
      body: JSON.stringify(val),
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.log('error: ', error)
    throw error
  }
}

export const del = async (url, val, token = null) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    }

    const response = await fetch(`${baseUrl}${url}`, {
      method: 'DELETE',
      headers,
      body: JSON.stringify(val),
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.log('error: ', error)
    throw error
  }
}

export const textCleanup = (str) => {
  return str
    ?.split('')
    .join('›')
    .split('<br>`<br>')
    .join('₹')
    .split('<br/>`<br/>')
    .join('₹')
    .split('<br/>₹<br/>')
    .join('₹')
    .split('<br>`')
    .join('₹')
    .split('`<br>')
    .join('₹')
    .split('`')
    .join('₹')
    .split('<br>¤<br>')
    .join('€')
    .split('<br>¤')
    .join('€')
    .split('¤<br>')
    .join('€')
    .split('¤')
    .join('€')
    ?.split('<br>')
    ?.join('<br/>')
    .split('&lt')
    .join('<')
    .split('&gt;')
    .join('>')
}

export const removeBR = (str) => {
  return str.replaceAll('<br/>', '').replaceAll('<br>', '').replaceAll('</br>', '')
}

export const displayToastr = (message, title, duration, type) => {
  toastr.options = {
    positionClass: 'toast-top-right',
    timeOut: duration,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
    showDuration: 300,
    hideDuration: 1000,
  }
  if (type === 'error') {
    toastr.warning(message, title)
  } else {
    toastr[type](message, title)
  }
}
